<template>
  <div class="mb-7">
    <v-expansion-panels :class="{ 'on-add': onAddingProcess }" accordion expansion-panel-border-radius="30">
      <!--General Informations Section-->
      <v-expansion-panel>
        <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red"
          >General Informations
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field
                :value="tenant.id"
                v-model="tenant.id"
                label="Tenant Id"
                dense
                hide-details="auto"
                outlined
                required></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.name"
                dense
                v-model="tenant.name"
                label="Name"
                hide-details="auto"
                outlined
                required></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.bookingAffiliateId"
                dense
                v-model="tenant.bookingAffiliateId"
                label="Booking Affiliate ID"
                hide-details="auto"
                outlined
                required></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="tenant.allowedBookingSystems"
                :items="bookingSystems"
                label="Booking Systems"
                multiple
                dense
                hide-details="auto"
                outlined
                chips
                small-chips
                deletable-chips></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="tenant.allowedPaymentSystems"
                :items="paymentSystems"
                label="Payment Systems"
                multiple
                dense
                hide-details="auto"
                outlined
                chips
                small-chips
                deletable-chips></v-select>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.isOwnedByTrainPlanet"
                inset
                :label="'Is owned by Trainplanet'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.canUseGiftCards"
                inset
                :label="'Can Sell & Use Gift Cards'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.canSellJourneys"
                inset
                :label="'Can Sell Journeys'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.canSellRailPassSeatReservations"
                inset
                :label="'Can Sell Rail Pass Seat Reservations'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.canSellRailPasses"
                inset
                :label="'Can Sell Rail Passes'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.canSellTicketsByInvoice"
                inset
                :label="'Can Sell Tickets By Invoice'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.canSellTaxis"
                inset
                :label="'Can Sell Taxis'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.nationalIdNumberVerificationRequired"
                inset
                :label="'Requires National ID Verification'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.useMainTenantsNameForToSInEPSPayload"
                inset
                label="Display Main Tenant's Name in Terms & Conditions for EPS"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.showNewsletterCheckboxInCheckout"
                inset
                :label="'Show Newsletter Checkbox In Checkout'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.useCustomConsent"
                inset
                :label="'Use Custom Consent'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch hide-details="auto" color="greeny" v-model="tenant.isTora" inset :label="'Is Tora'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.sendPaymentReminderEmails"
                inset
                :label="'Send Payment Reminder Emails'"></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                hide-details="auto"
                color="greeny"
                v-model="tenant.showTaxiInCheckout"
                inset
                :label="'Show Taxi In Checkout'"></v-switch>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Email Credentials Section-->
      <v-expansion-panel>
        <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red"
          >Email Credentials
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="6">
              <v-text-field
                dense
                :value="tenant.emailCredentials.fromAddress"
                v-model="tenant.emailCredentials.fromAddress"
                label="From Address"
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                dense
                :value="tenant.emailCredentials.fromName"
                v-model="tenant.emailCredentials.fromName"
                label="From Name"
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                dense
                :value="tenant.emailCredentials.host"
                v-model="tenant.emailCredentials.host"
                label="Host"
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="tenant.emailCredentials.username"
                dense
                v-model="tenant.emailCredentials.username"
                label="Username"
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="tenant.emailCredentials.port"
                dense
                v-model.number="tenant.emailCredentials.port"
                label="Port"
                hide-details="auto"
                outlined
                type="number"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="tenant.emailCredentials.password"
                dense
                v-model="tenant.emailCredentials.password"
                label="Password"
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- Theme Informations Section     -->
      <v-expansion-panel>
        <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red">
          Theme Informations
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.mainColor"
                v-model="tenant.theme.mainColor"
                label="Main Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.secondaryColor"
                v-model="tenant.theme.secondaryColor"
                label="Secondary Color"
                dense
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.headerColor"
                v-model="tenant.theme.headerColor"
                label="Header Color"
                dense
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.headerTitleColor"
                v-model="tenant.theme.headerTitleColor"
                label="Header Title Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.titleColor"
                v-model="tenant.theme.titleColor"
                label="Title Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.titleBackgroundColor"
                v-model="tenant.theme.titleBackgroundColor"
                label="Title Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.darkColor"
                v-model="tenant.theme.darkColor"
                label="Dark Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.positiveColor"
                v-model="tenant.theme.positiveColor"
                label="Positive Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.negativeColor"
                v-model="tenant.theme.negativeColor"
                label="Negative Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.headerBackgroundColor"
                v-model="tenant.theme.headerBackgroundColor"
                label="Header Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.toolbarBackgroundColor"
                v-model="tenant.theme.toolbarBackgroundColor"
                label="Toolbar Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.sectionHeaderBackgroundColor"
                v-model="tenant.theme.sectionHeaderBackgroundColor"
                label="Section Header Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.navBarBackgroundColor"
                v-model="tenant.theme.navBarBackgroundColor"
                label="Navbar Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.appBackgroundColor"
                v-model="tenant.theme.appBackgroundColor"
                label="App Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.mutedColor"
                v-model="tenant.theme.mutedColor"
                label="Muted Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.borderColor"
                v-model="tenant.theme.borderColor"
                label="Border Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.accentColor"
                v-model="tenant.theme.accentColor"
                label="Accent Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.infoColor"
                v-model="tenant.theme.infoColor"
                label="Info Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.warningColor"
                v-model="tenant.theme.warningColor"
                label="Warning Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.travelModeBackgroundColor"
                v-model="tenant.theme.travelModeBackgroundColor"
                label="Travel Mode Tab Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.travelModeBackgroundOpacity"
                v-model.number="tenant.theme.travelModeBackgroundOpacity"
                label="Travel Mode Tab Background Opacity"
                hide-details="auto"
                dense
                type="number"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.selectedTravelModeTabBackgroundColor"
                v-model="tenant.theme.selectedTravelModeTabBackgroundColor"
                label="Selected Travel Mode Tab Background Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.actionColor"
                v-model="tenant.theme.actionColor"
                label="Action Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.genericIconColor"
                v-model="tenant.theme.genericIconColor"
                label="Generic Icon Color"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.genericBorderRadius"
                v-model="tenant.theme.genericBorderRadius"
                label="Generic Border Radius"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.mainActionButtonRadius"
                v-model="tenant.theme.mainActionButtonRadius"
                label="Main Action Button Radius"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.fontFamily"
                v-model="tenant.theme.fontFamily"
                label="Font Family"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.genericLetterSpacing"
                v-model="tenant.theme.genericLetterSpacing"
                label="Generic Letter Spacing"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.mainColorSvgFilters"
                v-model="tenant.theme.mainColorSvgFilters"
                label="Main Color Svg Filters"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.secondaryColorSvgFilters"
                v-model="tenant.theme.secondaryColorSvgFilters"
                label="Secondary Color Svg Filters"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.mainPageUrl"
                v-model.trim="tenant.theme.mainPageUrl"
                label="Main Page URL"
                dense
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.shopUrl"
                v-model.trim="tenant.theme.shopUrl"
                label="Shop URL"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.customerPageUrl"
                v-model.trim="tenant.theme.customerPageUrl"
                label="Customer Page URL"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.supportNumber"
                v-model="tenant.theme.supportNumber"
                label="Support Number"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.supportEmail"
                v-model="tenant.theme.supportEmail"
                label="Support Email"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.termsAndConditionsPageUrl"
                v-model.trim="tenant.theme.termsAndConditionsPageUrl"
                label="ToS Page URL"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.accessibilityUrl"
                v-model.trim="tenant.theme.accessibilityUrl"
                label="Accessibility Page URL"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.searchUrl"
                v-model.trim="tenant.theme.searchUrl"
                label="Search URL"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.logoUrl"
                v-model.trim="tenant.theme.logoUrl"
                label="Logo SVG URL"
                dense
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.logoPngUrl"
                v-model.trim="tenant.theme.logoPngUrl"
                label="Logo PNG URL"
                dense
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.blackLogoUrl"
                v-model.trim="tenant.theme.blackLogoUrl"
                label="Black Logo URL"
                dense
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.logoWidth"
                v-model="tenant.theme.logoWidth"
                label="Logo Width"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.gtmId"
                v-model="tenant.theme.gtmId"
                label="GTM ID"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.loadingAnimationUrl"
                v-model.trim="tenant.theme.loadingAnimationUrl"
                label="Loading Animation URL"
                dense
                hide-details="auto"
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.footerLogoUrl"
                v-model.trim="tenant.theme.footerLogoUrl"
                label="Footer Logo URL"
                hide-details="auto"
                dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.poweredByLogoUrl"
                v-model.trim="tenant.theme.poweredByLogoUrl"
                label="Powered By Logo URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.favIconUrl"
                v-model="tenant.theme.favIconUrl"
                label="Fav Icon URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.favIcon16Url"
                v-model="tenant.theme.favIcon16Url"
                label="Fav Icon 16x16 URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.favIcon32Url"
                v-model="tenant.theme.favIcon32Url"
                label="Fav Icon 32x32 URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.appleTouchIconUrl"
                v-model="tenant.theme.appleTouchIconUrl"
                label="Apple Touch Icon URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.maskIconUrl"
                v-model="tenant.theme.maskIconUrl"
                label="Mask Icon URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.webManifestUrl"
                v-model="tenant.theme.webManifestUrl"
                label="Web Manifest URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.browserConfigUrl"
                v-model="tenant.theme.browserConfigUrl"
                label="Browser Config URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.fontCssUrl"
                v-model="tenant.theme.fontCssUrl"
                label="Font CSS URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.giftCardBackgroundImageUrl"
                v-model.trim="tenant.theme.giftCardBackgroundImageUrl"
                label="Gift Card Background Image URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="tenant.theme.customerPageBackgroundUrl"
                @input="$set(tenant.theme, 'customerPageBackgroundUrl', ($event || '').trim() || null)"
                label="Customer Page Background URL"
                hide-details="auto"
                outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                outlined
                class="align-stretch font-weight-bold"
                v-model="tenant.theme.languages"
                :items="locales"
                chips
                item-value="value"
                item-text="text"
                :menu-props="{ maxHeight: '400' }"
                label="Select languages"
                multiple
                hide-details
                :persistent-hint="false"></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                outlined
                class="align-stretch font-weight-bold"
                v-model="tenant.theme.currencies"
                :items="currencies"
                chips
                item-value="id"
                item-text="name"
                :menu-props="{ maxHeight: '400' }"
                label="Select currencies"
                multiple
                hide-details
                :persistent-hint="false">
              </v-select>
            </v-col>
          </v-row>

          <!-- Theme Toggle Options -->
          <v-row class="mt-4" align="center">
            <v-col cols="4" class="d-flex align-center">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showCurrencyPicker"
                inset
                :label="'Show Currency Picker'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showPeriodCardToggle"
                inset
                :label="'Show Period Card Toggle'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showTrainVacationCardToggle"
                inset
                :label="'Show Train Vacation Card Toggle'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showInterrailToggle"
                inset
                :label="'Show Interrail Toggle'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showPromoCodeInputField"
                inset
                :label="'Show Promo Code Input Field'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.plainCodeFields"
                inset
                :label="'Plain Promo Code'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.borderBottomOnHeader"
                inset
                :label="'Border Bottom On Header'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showFaqButton"
                inset
                :label="'Show FAQ Button'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showJourneyOverviewIcons"
                inset
                :label="'Show Journey Overview Icons'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="4">
              <v-switch
                color="greeny"
                v-model="tenant.theme.showCorporateAgreementsCodeInputField"
                inset
                :label="'Show Corporate Agreement Codes Input Field'"
                hide-details="auto"
                dense
                outlined></v-switch>
            </v-col>
            <v-col cols="8">
              <v-row align="center">
                <v-col cols="3">
                  <v-switch
                    color="greeny"
                    v-model="tenant.theme.preferOutline"
                    inset
                    :label="'Prefer Outline'"
                    hide-details="auto"
                    dense
                    outlined></v-switch>
                </v-col>
                <v-col cols="9" v-show="tenant.theme.preferOutline">
                  <v-text-field
                    :value="tenant.theme.outlinedFieldColor"
                    v-model="tenant.theme.outlinedFieldColor"
                    label="Outlined Field Color"
                    hide-details="auto"
                    dense
                    outlined></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Icons Section with Accordion -->
          <v-expansion-panels class="my-8" accordion>
            <!-- General Icons -->
            <v-expansion-panel>
              <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red">
                General Icons
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.generalIcons.info.name"
                      v-model="tenant.theme.generalIcons.info.name"
                      label="Info Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.generalIcons.info.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Search Engine Icons -->
            <v-expansion-panel>
              <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red">
                Search Engine Icons
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.singleTickets.name"
                      v-model="tenant.theme.searchEngineIcons.singleTickets.name"
                      label="Single Tickets Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.singleTickets.color"
                      v-model="tenant.theme.searchEngineIcons.singleTickets.color"
                      label="Single Tickets Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.singleTickets.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.periodTickets.name"
                      v-model="tenant.theme.searchEngineIcons.periodTickets.name"
                      label="Period Tickets Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.periodTickets.color"
                      v-model="tenant.theme.searchEngineIcons.periodTickets.color"
                      label="Period Tickets Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.periodTickets.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.oneWay.name"
                      v-model="tenant.theme.searchEngineIcons.oneWay.name"
                      label="One Way Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.oneWay.color"
                      v-model="tenant.theme.searchEngineIcons.oneWay.color"
                      label="One Way Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.oneWay.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.withReturn.name"
                      v-model="tenant.theme.searchEngineIcons.withReturn.name"
                      label="With Return Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.withReturn.color"
                      v-model="tenant.theme.searchEngineIcons.withReturn.color"
                      label="With Return Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.withReturn.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.swap.name"
                      v-model="tenant.theme.searchEngineIcons.swap.name"
                      label="Swap Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.swap.color"
                      v-model="tenant.theme.searchEngineIcons.swap.color"
                      label="Swap Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.swap.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.from.name"
                      v-model="tenant.theme.searchEngineIcons.from.name"
                      label="From Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.from.color"
                      v-model="tenant.theme.searchEngineIcons.from.color"
                      label="From Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.from.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.to.name"
                      v-model="tenant.theme.searchEngineIcons.to.name"
                      label="To Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.to.color"
                      v-model="tenant.theme.searchEngineIcons.to.color"
                      label="To Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.to.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.datepicker.name"
                      v-model="tenant.theme.searchEngineIcons.datepicker.name"
                      label="Datepicker Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.datepicker.color"
                      v-model="tenant.theme.searchEngineIcons.datepicker.color"
                      label="Datepicker Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.datepicker.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.datepickerOutboundTime.name"
                      v-model="tenant.theme.searchEngineIcons.datepickerOutboundTime.name"
                      label="Datepicker Outbound Time Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.datepickerOutboundTime.color"
                      v-model="tenant.theme.searchEngineIcons.datepickerOutboundTime.color"
                      label="Datepicker Outbound Time Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.datepickerOutboundTime.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.datepickerInboundTime.name"
                      v-model="tenant.theme.searchEngineIcons.datepickerInboundTime.name"
                      label="Datepicker Inbound Time Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.datepickerInboundTime.color"
                      v-model="tenant.theme.searchEngineIcons.datepickerInboundTime.color"
                      label="Datepicker Inbound Time Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.datepickerInboundTime.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.passengerPicker.name"
                      v-model="tenant.theme.searchEngineIcons.passengerPicker.name"
                      label="Passenger Picker Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      :value="tenant.theme.searchEngineIcons.passengerPicker.color"
                      v-model="tenant.theme.searchEngineIcons.passengerPicker.color"
                      label="Passenger Picker Icon Color"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.searchEngineIcons.passengerPicker.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Timetable Icons -->
            <v-expansion-panel>
              <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red">
                Timetable Icons
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.timetableIcons.duration.name"
                      v-model="tenant.theme.timetableIcons.duration.name"
                      label="Duration Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.timetableIcons.duration.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.timetableIcons.changes.name"
                      v-model="tenant.theme.timetableIcons.changes.name"
                      label="Changes Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.timetableIcons.changes.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.timetableIcons.transport.name"
                      v-model="tenant.theme.timetableIcons.transport.name"
                      label="Transport Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.timetableIcons.transport.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.timetableIcons.operators.name"
                      v-model="tenant.theme.timetableIcons.operators.name"
                      label="Operators Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.timetableIcons.operators.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.timetableIcons.seat.name"
                      v-model="tenant.theme.timetableIcons.seat.name"
                      label="Seat Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.timetableIcons.seat.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.timetableIcons.couchette.name"
                      v-model="tenant.theme.timetableIcons.couchette.name"
                      label="Couchette Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.timetableIcons.couchette.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.timetableIcons.berth.name"
                      v-model="tenant.theme.timetableIcons.berth.name"
                      label="Berth Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.timetableIcons.berth.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Passenger Icons -->
            <v-expansion-panel>
              <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red">
                Passenger Icons
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.passengerIcons.adult.name"
                      v-model="tenant.theme.passengerIcons.adult.name"
                      label="Adult Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.passengerIcons.adult.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.passengerIcons.childYouth.name"
                      v-model="tenant.theme.passengerIcons.childYouth.name"
                      label="Child/Youth Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.passengerIcons.childYouth.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.passengerIcons.student.name"
                      v-model="tenant.theme.passengerIcons.student.name"
                      label="Student Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.passengerIcons.student.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.passengerIcons.retired.name"
                      v-model="tenant.theme.passengerIcons.retired.name"
                      label="Retired Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.passengerIcons.retired.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.passengerIcons.senior.name"
                      v-model="tenant.theme.passengerIcons.senior.name"
                      label="Senior Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.passengerIcons.senior.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Toolbar Icons -->
            <v-expansion-panel>
              <v-expansion-panel-header class="text-subtitle-1 font-weight-bold mango-red">
                Toolbar Icons
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.toolbarIcons.supportNumber.name"
                      v-model="tenant.theme.toolbarIcons.supportNumber.name"
                      label="Support Number Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.toolbarIcons.supportNumber.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.toolbarIcons.supportEmail.name"
                      v-model="tenant.theme.toolbarIcons.supportEmail.name"
                      label="Support Email Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.toolbarIcons.supportEmail.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.toolbarIcons.funka.name"
                      v-model="tenant.theme.toolbarIcons.funka.name"
                      label="Funka Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.toolbarIcons.funka.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.toolbarIcons.search.name"
                      v-model="tenant.theme.toolbarIcons.search.name"
                      label="Search Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.toolbarIcons.search.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.toolbarIcons.contact.name"
                      v-model="tenant.theme.toolbarIcons.contact.name"
                      label="Contact Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.toolbarIcons.contact.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenant.theme.toolbarIcons.user.name"
                      v-model="tenant.theme.toolbarIcons.user.name"
                      label="User Icon"
                      hide-details="auto"
                      dense
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <v-switch
                      color="greeny"
                      v-model="tenant.theme.toolbarIcons.user.isCustom"
                      inset
                      label="Is Custom"
                      hide-details="auto"
                      dense
                      class="ma-0 pa-0"
                      outlined></v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div>
            <v-row>
              <!--TOOLBAR OPTIONS-->
              <v-col cols="2" class="mt-4">
                <h3>Toolbar Options</h3>
              </v-col>
              <v-col cols="10">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.toolbarOptions.enabled"
                  inset
                  label="Show Toolbar"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.toolbarOptions.showContactButton"
                  inset
                  :label="'Show Contact Button'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.toolbarOptions.showCustomerPageButton"
                  inset
                  :label="'Show Customer Page Button'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.toolbarOptions.showFunkaButton"
                  inset
                  :label="'Show Funka Button'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.toolbarOptions.showMailButton"
                  inset
                  :label="'Show Mail Button'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.toolbarOptions.showPhoneButton"
                  inset
                  :label="'Show Phone Button'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.toolbarOptions.showSearchButton"
                  inset
                  :label="'Show Search Button'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
            </v-row>
          </div>
          <!--WIDGET SETTINGS-->
          <div>
            <v-row>
              <v-col cols="2" class="mt-4">
                <h3>Widget Settings</h3>
              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="tenant.theme.widgetSettings.tabBackgroundOpacity"
                  v-model="tenant.theme.widgetSettings.tabBackgroundOpacity"
                  label="Tab Background Opacity"
                  hide-details="auto"
                  dense
                  outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="tenant.theme.widgetSettings.searchBarBackgroundColor"
                  v-model="tenant.theme.widgetSettings.searchBarBackgroundColor"
                  label="Search Bar Background Color"
                  hide-details="auto"
                  dense
                  outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="tenant.theme.widgetSettings.promoCodesBackgroundColor"
                  v-model="tenant.theme.widgetSettings.promoCodesBackgroundColor"
                  label="Promo Codes Background Color"
                  hide-details="auto"
                  dense
                  outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="widgetLayoutModes"
                  v-model="widgetLayoutMode"
                  item-value="value"
                  item-text="text"
                  label="Layout Mode"
                  hide-details="auto"
                  dense
                  outlined></v-select>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.widgetSettings.darkInterrailToggle"
                  inset
                  :label="'Dark Interrail Toggle'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
              <v-col cols="4">
                <v-switch
                  color="greeny"
                  v-model="tenant.theme.widgetSettings.showSearchBarBackground"
                  inset
                  :label="'Show Search Bar Background'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
            </v-row>
          </div>
          <!--Support Page-->
          <div>
            <v-row>
              <h3 class="ml-3 mt-6">Support Page</h3>
              <v-spacer></v-spacer>
              <v-btn @click="addItemsupport" class="text-none mr-3 mb-4 mt-5 third white--text">
                <v-icon left dark>mdi-playlist-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </v-row>
            <v-row cols v-for="(supportPageUrl, index) in tenant.theme.supportPageUrls" :key="index">
              <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                <v-select
                  class="align-stretch"
                  :items="locales"
                  v-model="supportPageUrl.locale"
                  label="Support Page language"
                  hide-details="auto"
                  item-value="value"
                  item-text="text"
                  outlined></v-select>
              </v-col>
              <v-col cols="12" lg="9" md="12" sm="12" xs="12">
                <v-text-field
                  class="mt-2"
                  :rules="[rules.required]"
                  v-model="supportPageUrl.url"
                  label="Support Page URL"
                  hide-details="auto"
                  dense
                  outlined>
                  <template v-slot:append-outer>
                    <v-btn color="red" class="mt-2 mr-lg-n3 mt-lg-n2" icon @click="removeItemsupport(index)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <!--Traffic Page-->
          <div>
            <v-row>
              <h3 class="ml-3 mt-6">Traffic Page</h3>
              <v-spacer></v-spacer>
              <v-btn @click="addItemTrafficPage" class="text-none mr-3 mb-4 mt-5 third white--text">
                <v-icon left dark>mdi-playlist-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </v-row>
            <v-row cols v-for="(trafficPageUrl, index) in tenant.theme.trafficPageUrls" :key="index">
              <v-col cols="12" lg="3" md="12" sm="12" xs="12">
                <v-select
                  class="align-stretch"
                  :items="locales"
                  v-model="trafficPageUrl.locale"
                  label="Traffic Page language"
                  hide-details="auto"
                  item-value="value"
                  item-text="text"
                  outlined></v-select>
              </v-col>
              <v-col cols="12" lg="9" md="12" sm="12" xs="12">
                <v-text-field
                  class="mt-2"
                  :rules="[rules.required]"
                  v-model="trafficPageUrl.url"
                  label="Traffic Page URL"
                  hide-details="auto"
                  dense
                  outlined>
                  <template v-slot:append-outer>
                    <v-btn color="red" class="mt-2 mr-lg-n3 mt-lg-n2" icon @click="removeItemTrafficPage(index)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <!--Group Order-->
          <div>
            <v-row>
              <h3 class="ml-3 mt-6">Group Order</h3>
              <v-spacer></v-spacer>
              <v-btn @click="addItem" class="text-none mr-3 mb-4 mt-5 third white--text">
                <v-icon left dark>mdi-playlist-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </v-row>
            <v-row cols v-for="(groupOrderLinks, index) in tenant.theme.groupOrderLinks" :key="index">
              <v-col cols="3">
                <v-select
                  :items="locales"
                  v-model="groupOrderLinks.locale"
                  label="Group Order Links language"
                  hide-details="auto"
                  item-value="value"
                  item-text="text"
                  outlined></v-select>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  class="mt-2"
                  :rules="[rules.required]"
                  v-model="groupOrderLinks.url"
                  label="Group Order Links URL"
                  hide-details="auto"
                  dense
                  outlined>
                  <template v-slot:append-outer>
                    <v-btn color="red" icon class="mt-2 mr-lg-n3 mt-lg-n2" @click="removeItem(index)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div>
            <!--  Navigation Menu-->
            <v-row>
              <v-col cols="2">
                <h3 class="mt-3 mb-3">Navigation Menu</h3>
              </v-col>
              <v-col cols="10">
                <v-switch
                  class="mt-3 mb-3"
                  color="greeny"
                  v-model="tenant.theme.showNavigationMenu"
                  inset
                  :label="'Show Navigation Menu'"
                  hide-details="auto"
                  dense
                  outlined></v-switch>
              </v-col>
            </v-row>
            <div>
              <v-tabs class="mb-4" v-model="activeNavigationMenuIndex" show-arrows>
                <v-tab
                  class="ml-2"
                  v-for="(navigationMenu, navigationMenuIndex) in tenant.theme.navigationMenu || []"
                  :key="navigationMenuIndex">
                  {{ localeText(navigationMenu.locale) }}
                  <v-btn color="red" icon @click.stop="removeNavigationMenu(navigationMenuIndex)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-tab>
                <div class="mt-2">
                  <v-select
                    label="Add New Translation"
                    class="mb-4 ml-7 pa-0"
                    :items="locales | notIn(locales, tenant.theme.navigationMenu || [])"
                    hide-details="auto"
                    @change="addNavigationMenu"
                    item-value="value"
                    item-text="text"
                    style="max-width: max-content"
                    :persistent-hint="false"></v-select>
                </div>
              </v-tabs>

              <v-card v-if="activeNavigationMenu" class="elevation-1 mb-7">
                <v-toolbar flat>
                  <v-toolbar-title>Items</v-toolbar-title>
                  <span class="text-caption grey--text ml-3">
                    {{ (activeNavigationMenu.items || []).length }} items
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" dark @click="addNavigationMenuItem(activeNavigationMenuIndex)">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    Add Item
                  </v-btn>
                </v-toolbar>

                <v-expansion-panels
                  v-if="(activeNavigationMenu.items || []).length"
                  v-model="openNavigationMenuItems"
                  accordion
                  multiple
                  flat
                  class="px-4 pb-4">
                  <v-expansion-panel
                    v-for="(item, navigationMenuItemIndex) in activeNavigationMenu.items"
                    :key="navigationMenuItemIndex"
                    ref="navigationMenuItemPanels"
                    class="navigation-menu-panel">
                    <v-expansion-panel-header>
                      <div class="d-flex align-center flex-grow-1 navigation-menu-summary">
                        <span class="font-weight-medium">{{ item.title || "New item" }}</span>
                        <span class="text-caption grey--text ml-3 text-truncate">{{ item.url || "No URL" }}</span>
                        <v-chip v-if="item.icon && item.icon.name" class="ml-3" x-small label outlined>{{
                          item.icon.name
                        }}</v-chip>
                        <v-chip class="ml-3" x-small label outlined>
                          {{ (item.childItems || []).length }} child items
                        </v-chip>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="mr-2"
                          color="red"
                          icon
                          small
                          @click.stop="removeNavigationMenuItem(activeNavigationMenuIndex, navigationMenuItemIndex)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-row dense>
                        <v-col cols="12" md="5">
                          <v-text-field
                            :rules="[rules.required]"
                            v-model="item.title"
                            label="Title"
                            hide-details="auto"
                            dense
                            outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" md="7">
                          <v-text-field
                            v-model="item.url"
                            label="URL"
                            placeholder="Leave empty if the item only opens its child items"
                            hide-details="auto"
                            dense
                            outlined></v-text-field>
                        </v-col>
                      </v-row>
                      <icon-fields v-model="item.icon"></icon-fields>

                      <div class="navigation-menu-children pa-3 mt-4">
                        <div class="d-flex align-center mb-3">
                          <span class="text-subtitle-2">Child Items</span>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="text-none white--text"
                            color="third"
                            small
                            depressed
                            @click="addNavigationMenuItemChildItem(activeNavigationMenuIndex, navigationMenuItemIndex)">
                            <v-icon left small>mdi-playlist-plus</v-icon>
                            Add Child Item
                          </v-btn>
                        </div>
                        <div v-if="!(item.childItems || []).length" class="text-caption grey--text">
                          No child items.
                        </div>
                        <v-card
                          v-for="(childItem, navigationMenuItemChildItemIndex) in item.childItems || []"
                          :key="navigationMenuItemChildItemIndex"
                          class="d-flex align-center pa-3 mb-2"
                          outlined>
                          <div class="flex-grow-1">
                            <v-row dense>
                              <v-col cols="12" md="5">
                                <v-text-field
                                  :rules="[rules.required]"
                                  v-model="childItem.title"
                                  label="Title"
                                  hide-details="auto"
                                  dense
                                  outlined></v-text-field>
                              </v-col>
                              <v-col cols="12" md="7">
                                <v-text-field
                                  :rules="[rules.required]"
                                  v-model="childItem.url"
                                  label="URL"
                                  hide-details="auto"
                                  dense
                                  outlined></v-text-field>
                              </v-col>
                            </v-row>
                            <icon-fields v-model="childItem.icon"></icon-fields>
                          </div>
                          <v-btn
                            class="ml-2"
                            color="red"
                            icon
                            small
                            @click="
                              removeNavigationMenuItemChildItem(
                                activeNavigationMenuIndex,
                                navigationMenuItemIndex,
                                navigationMenuItemChildItemIndex
                              )
                            ">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </v-card>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <div v-else class="text-caption grey--text px-4 pb-4">No items yet.</div>
              </v-card>
            </div>
          </div>
          <!-- Favorite Destinations -->
          <div>
            <v-row>
              <h3 class="ml-3 mt-6">Favorite Destinations</h3>
              <v-spacer></v-spacer>
              <v-btn @click="addFavoriteDestination" class="text-none mr-3 mb-4 mt-5 third white--text">
                <v-icon left dark>mdi-playlist-plus</v-icon>
                <span>Add Destination</span>
              </v-btn>
            </v-row>
            <v-row cols v-for="(destination, index) in tenant.theme.favoriteDestinations" :key="index">
              <v-col cols="4">
                <v-text-field
                  class="mt-2"
                  v-model="destination.id"
                  label="Destination ID"
                  hide-details="auto"
                  dense
                  outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  class="mt-2"
                  v-model="destination.name"
                  label="Destination Name"
                  hide-details="auto"
                  dense
                  outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  class="mt-2"
                  v-model.number="destination.countryCodeUIC"
                  label="Country Code UIC"
                  hide-details="auto"
                  dense
                  outlined
                  type="number">
                  <template v-slot:append-outer>
                    <v-btn color="red" class="mt-2 mr-lg-n3 mt-lg-n2" icon @click="removeFavoriteDestination(index)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <!-- Default Means of Transport -->
          <div>
            <v-row>
              <h3 class="ml-3 mt-6">Default Means of Transport</h3>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  outlined
                  v-model="tenant.theme.defaultTransportModes"
                  :items="transportModes"
                  item-value="value"
                  item-text="text"
                  label="Select Transport Modes"
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  hide-details="auto"
                  :menu-props="{ maxHeight: '400' }"></v-select>
              </v-col>
            </v-row>
          </div>
          <!-- Domains -->
          <div>
            <v-row>
              <h3 class="ml-3 mt-6 mr-3">Domains</h3>

              <v-tooltip top color="black" style="max-width: 10px">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                </template>
                <div style="max-width: 300px">
                  These domains are used to detect a tenant's identity by domain. There should be no 'https://', no
                  'www' or no ending '/' at the end. Example: 'trainplanet.com' (no quotes)
                </div>
              </v-tooltip>

              <v-spacer></v-spacer>
              <v-btn @click="addDomain" class="text-none mr-3 mb-4 mt-5 third white--text">
                <v-icon left dark>mdi-playlist-plus</v-icon>
                <span>Add Domain</span>
              </v-btn>
            </v-row>
            <v-row v-for="(domain, domainIndex) in tenant.theme.domains" :key="domainIndex">
              <v-col>
                <v-text-field
                  class="mt-2"
                  :rules="[rules.required]"
                  v-model="tenant.theme.domains[domainIndex]"
                  label="Domain URL"
                  hide-details="auto"
                  dense
                  outlined>
                  <template v-slot:append-outer>
                    <v-btn color="red" class="mt-2 mr-lg-n3 mt-lg-n2" icon @click="removeDomain(domainIndex)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import { VueEditor } from "vue2-editor";
import IconFields, { blankIcon } from "./IconFields.vue";

export default {
  components: { Header, VueEditor, IconFields },
  props: ["tenant", "onAddingProcess", "currencies", "locales", "emptyTranslation", "bookingSystems", "paymentSystems"],
  data: () => ({
    loading: false,
    activeNavigationMenuIndex: 0,
    openNavigationMenuItems: [],
    rules: {
      required: (value) => !!value || "Field is required",
    },
    transportModes: [
      { value: "HIGH_SPEED_TRAIN", text: "High Speed Train" },
      { value: "INTERCITY_REGIONAL", text: "Intercity & Regional Train" },
      { value: "LOCAL_TRAIN", text: "Local Train" },
      { value: "LONG_DISTANCE", text: "Long Distance Bus" },
      { value: "LOCAL_BUS", text: "Local Bus" },
      { value: "SUBWAY", text: "Subway" },
      { value: "TRAMS", text: "Tram" },
      { value: "FERRY", text: "Ferry" },
      { value: "TAXI", text: "Taxi" },
    ],
    widgetLayoutModes: [
      { value: "auto", text: "Auto (follows the container width)" },
      { value: "mobile", text: "Mobile" },
      { value: "tablet", text: "Tablet" },
      { value: "desktop", text: "Desktop" },
    ],
  }),
  filters: {
    notIn(locales, navigationMenus) {
      navigationMenus = JSON.parse(JSON.stringify(navigationMenus || []));
      return locales.filter(
        (locale) => !navigationMenus.some((navigationMenu) => navigationMenu.locale === locale.value)
      );
    },
  },
  computed: {
    // An existing tenant has no `layoutMode` key, so it has to be added with `$set` to stay
    // reactive, and a missing one reads as the layout the widget falls back to.
    widgetLayoutMode: {
      get() {
        return this.tenant.theme.widgetSettings?.layoutMode || "auto";
      },
      set(layoutMode) {
        this.$set(this.tenant.theme.widgetSettings, "layoutMode", layoutMode);
      },
    },
    activeNavigationMenu() {
      return (this.tenant.theme.navigationMenu || [])[this.activeNavigationMenuIndex] || null;
    },
    editing: {
      get() {
        return Object.keys(this.navigationMenu).length !== 0;
      },
      set(doing) {
        if (!doing) {
          this.$emit("item:cleared");
        }
      },
    },
  },
  watch: {
    "tenant.theme.preferOutline"(newValue) {
      if (!newValue) {
        this.tenant.theme.outlinedFieldColor = null;
      }
    },
    // The item panels are open by position, so they are closed when another translation is picked.
    activeNavigationMenuIndex() {
      this.openNavigationMenuItems = [];
    },
  },
  methods: {
    removeItem(index) {
      this.tenant.theme.groupOrderLinks.splice(index, 1);
    },
    addItem() {
      this.tenant.theme.groupOrderLinks.push({
        locale: "",
        url: "",
      });
    },
    removeItemsupport(index) {
      this.tenant.theme.supportPageUrls.splice(index, 1);
    },
    addItemsupport() {
      this.tenant.theme.supportPageUrls.push({
        locale: "",
        url: "",
      });
    },
    removeItemTrafficPage(index) {
      this.tenant.theme.trafficPageUrls.splice(index, 1);
    },
    addItemTrafficPage() {
      // An existing tenant's theme has no `trafficPageUrls` key, so it has to be added with
      // `$set` to stay reactive.
      if (!this.tenant.theme.trafficPageUrls) {
        this.$set(this.tenant.theme, "trafficPageUrls", []);
      }
      this.tenant.theme.trafficPageUrls.push({
        locale: "",
        url: "",
      });
    },
    addNavigationMenu(languages) {
      if (!this.tenant.theme.navigationMenu) {
        this.$set(this.tenant.theme, "navigationMenu", []);
      }
      this.tenant.theme.navigationMenu.push({
        locale: languages,
        items: [],
      });
      // this.$refs.addItemnavigation.reset(); // Reset the select input
    },
    removeNavigationMenu(index) {
      if (this.tenant.theme.navigationMenu && this.tenant.theme.navigationMenu.length > 0) {
        this.tenant.theme.navigationMenu.splice(index, 1);
        if (this.activeNavigationMenuIndex >= this.tenant.theme.navigationMenu.length) {
          this.activeNavigationMenuIndex = Math.max(this.tenant.theme.navigationMenu.length - 1, 0);
        }
      }
    },
    addNavigationMenuItem(parentIndex) {
      const navigationMenu = this.tenant.theme.navigationMenu && this.tenant.theme.navigationMenu[parentIndex];
      if (!navigationMenu) {
        return;
      }
      if (!navigationMenu.items) {
        this.$set(navigationMenu, "items", []);
      }
      navigationMenu.items.push({
        title: "",
        url: "",
        icon: blankIcon(),
        childItems: [
          {
            title: "",
            url: "",
            icon: blankIcon(),
          },
        ],
      });

      const index = navigationMenu.items.length - 1;
      this.openNavigationMenuItems = [...this.openNavigationMenuItems, index];

      // The new item lands at the bottom of a long list, so it is scrolled to once it has rendered.
      this.$nextTick(() => {
        const panel = (this.$refs.navigationMenuItemPanels || [])[index];

        if (panel) panel.$el.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    },
    removeNavigationMenuItem(parentIndex, index) {
      const navigationMenu = this.tenant.theme.navigationMenu && this.tenant.theme.navigationMenu[parentIndex];
      if (navigationMenu && navigationMenu.items) {
        navigationMenu.items.splice(index, 1);
        this.openNavigationMenuItems = this.openNavigationMenuItems
          .filter((panel) => panel !== index)
          .map((panel) => (panel > index ? panel - 1 : panel));
      }
    },
    localeText(value) {
      const locale = this.locales.find((locale) => locale.value === value);
      return locale ? locale.text : value;
    },
    addNavigationMenuItemChildItem(grandparentIndex, parentIndex) {
      const navigationMenu = this.tenant.theme.navigationMenu && this.tenant.theme.navigationMenu[grandparentIndex];
      if (!navigationMenu || !navigationMenu.items || !navigationMenu.items[parentIndex]) {
        return;
      }
      if (!navigationMenu.items[parentIndex].childItems) {
        this.$set(navigationMenu.items[parentIndex], "childItems", []);
      }
      navigationMenu.items[parentIndex].childItems.push({
        title: "",
        url: "",
        icon: blankIcon(),
      });
    },
    removeNavigationMenuItemChildItem(grandparentIndex, parentIndex, index) {
      const navigationMenu = this.tenant.theme.navigationMenu && this.tenant.theme.navigationMenu[grandparentIndex];
      const item = navigationMenu && navigationMenu.items && navigationMenu.items[parentIndex];
      if (item && item.childItems) {
        item.childItems.splice(index, 1);
      }
    },
    addDomain() {
      this.tenant.theme.domains.push("");
    },
    removeDomain(index) {
      this.tenant.theme.domains.splice(index, 1);
    },
    addFavoriteDestination() {
      if (!this.tenant.theme.favoriteDestinations) {
        this.$set(this.tenant.theme, "favoriteDestinations", []);
      }
      this.tenant.theme.favoriteDestinations.push({
        id: "",
        name: "",
        countryCodeUIC: 74,
      });
    },
    removeFavoriteDestination(index) {
      this.tenant.theme.favoriteDestinations.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.navigation-menu-panel {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  margin-bottom: 8px;
}

/* A long URL would otherwise push the chips and the delete button out of the header. */
.navigation-menu-summary {
  min-width: 0;
}

.navigation-menu-children {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}
</style>
